import React from 'react'
import Note from '../Notes/advisor-components/Note'

const HHSearchNote = ({ note, query, advisors, meetings, queryKey }) => {
    // For search context, we'll use basic query keys that make sense for search results

    return (
        <div>
            <Note
                note={note}
                listQueryKey={queryKey}
                advisors={advisors} // We don't have advisors context in search, will handle gracefully
                meetings={meetings} // We don't have meetings context in search, will handle gracefully
                isAdvisor={true} // In client portal context
                query={query}
            />
        </div>
    )
}

export default HHSearchNote